import styled, { css } from 'styled-components';
import { Center, Col } from '@zillow/zrs-comet';
import { spaceMixin, mediaMixin } from '@zillow/constellation';
import ConnectedModuleCardConstants from 'app/shared/constants/ConnectedModuleCardConstants';
import InteractiveCard from 'app/shared/components/InteractiveCard';

export const ConnectedLeaseContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
`;

export const StyledCard = styled(InteractiveCard)`
    padding-top: ${spaceMixin('lg')};
    padding-bottom: ${spaceMixin('lg')};
    border-radius: 4px;
    box-shadow: 0 2px 10px 0 rgba(0,0,0,0.1);
    min-height: ${ConnectedModuleCardConstants.MANAGE_TENANTS_SPINNER_HEIGHT};

    ${mediaMixin('md', css`
        min-height: initial;
    `)}

    ${mediaMixin('lg', css`
        min-height: ${ConnectedModuleCardConstants.MANAGE_TENANTS_SPINNER_HEIGHT};
    `)}
`;

export const StyledCenter = styled(Center)`
    ${mediaMixin('md', css`
        text-align: initial;
    `)}

    ${mediaMixin('lg', css`
        text-align: center;
    `)}
`;

export const StyledCtaCol = styled(Col)`
    margin: auto;
    a {
        white-space: nowrap;
    }
`;
